import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    genericInfo: {
      fieldName: "",
      fieldType: "",
      irrigationType: "",
      fieldCulture: "",
      startDate: null,
      endDate: null,
      hasSubAreas: true,
    },
    cropHistory: [],
    fieldMap: {
      polygonCoordinates: [],
    },
    subAreas: [],
  },
};

const fieldFormSlice = createSlice({
  name: "fieldForm",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      const { key, data } = action.payload;
      state.formData[key] = data;
    },
    resetFormData: () => initialState,
  },
});

export const { updateFormData, resetFormData } = fieldFormSlice.actions;
export default fieldFormSlice.reducer;
